



























import Vue from "vue";
import data from "@/assets/data.json";

export default Vue.extend({
  name: "Talks",
  data: () => {
    return {
      talkskData: data.talks
    };
  },
  computed: {
    dataToDisplay: function() {
      return this.talkskData.filter(
        (d: { display: string }) => d.display === "TRUE"
      );
    }
  }
});
